module.exports = "../images/logo-typography.svg";